module.exports = __webpack_public_path__ + "img/rubin_benefit_05_bkk.a6fd973e.svg";